import controller from './bill-info.controller';

export default {
  bindings: {
    invoice: '<',
    offerable: '<'
  },
  controller,
  template: require('./bill-info.html')
};



// WEBPACK FOOTER //
// src/app/no-auth/components/bill-info/bill-info.component.ts